export const GB = () => {
  return (
    <>
      <g clipPath="url(#clip0_1073_12235)">
      <g clipPath="url(#clip1_1073_12235)">
      <rect width="96" height="96" fill="#0066FF"/>
      <rect x="-25.5391" y="-14.2253" width="16" height="192" transform="rotate(-45 -25.5391 -14.2253)" fill="white"/>
      <rect x="-14.2253" y="121.539" width="16" height="192" transform="rotate(-135 -14.2253 121.539)" fill="white"/>
      <rect x="-22.7107" y="-17.0538" width="8" height="192" transform="rotate(-45 -22.7107 -17.0538)" fill="#EF4444"/>
      <rect x="-17.0537" y="118.711" width="8" height="192" transform="rotate(-135 -17.0537 118.711)" fill="#EF4444"/>
      <rect x="31.9999" y="-48" width="32" height="192" fill="white"/>
      <rect x="-48" y="64" width="32" height="192" transform="rotate(-90 -48 64)" fill="white"/>
      <rect x="40" y="-47.9999" width="16" height="192" fill="#EF4444"/>
      <rect x="-48" y="56" width="16" height="192" transform="rotate(-90 -48 56)" fill="#EF4444"/>
      </g>
      </g>
      <rect x="2" y="2" width="92" height="92" rx="46" stroke="white" strokeOpacity="0.15" strokeWidth="4"/>
      <defs>
      <clipPath id="clip0_1073_12235">
      <rect width="96" height="96" rx="48" fill="white"/>
      </clipPath>
      <clipPath id="clip1_1073_12235">
      <rect width="96" height="96" rx="24" fill="white"/>
      </clipPath>
      </defs>
    </>
  )
}
